import { render, staticRenderFns } from "./ProposalForm.vue?vue&type=template&id=c5017c64&scoped=true&"
import script from "./ProposalForm.vue?vue&type=script&lang=js&"
export * from "./ProposalForm.vue?vue&type=script&lang=js&"
import style0 from "./ProposalForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProposalForm.vue?vue&type=style&index=1&id=c5017c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5017c64",
  null
  
)

export default component.exports